import { initializeApp } from "firebase/app";
import { getAuth, signOut } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { firebaseConfig, secondFirebaseConfig } from "./config";

// const app = process.env.NODE_ENV === "production"
//   ? initializeApp(firebaseConfig, "production")
//   : initializeApp(secondFirebaseConfig, "development");

const app = process.env.ENVIRONMENT === "production"
  ? initializeApp(firebaseConfig, "production")
  : initializeApp(secondFirebaseConfig, "development");


console.log(`Firebase initialized for ${process.env.ENVIRONMENT} environment.`);
console.log(`Using app name: ${app.name}`);


const auth = getAuth(app);
const db = getFirestore(app);

const logout = () => {
  signOut(auth);
};

export { auth, db, logout };
